import map from 'lodash/map.js';

import Model from '@/models/Model.js';
import ObjectiveCriteria from '@/models/ObjectiveCriteria.js';

export default class Objective extends Model {
    static entity = 'objectives';

    static modelName = 'Objective';

    static fields() {
        return {
            id: this.attr(null),
            courseable_id: this.attr(null),
            courseable_type: this.attr(null),
            subject_id: this.attr(null),
            subject_type: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            heading: this.attr(null),
            allow_objective_submissions: this.attr(null),

            ...super.fields(),

            courseable: this.morphTo('courseable_id', 'courseable_type_entity'),
            subject: this.morphTo('subject_id', 'subject_type_entity'),
            criterias: this.hasMany('objective_criterias', 'objective_id'),
        };
    }

    async remove() {
        const payload = this.$toJson();

        payload.criterias = ObjectiveCriteria.query()
            .where('objective_id', this.id)
            .where(criteria => !!criteria.description)
            .orderBy('order')
            .get()
            .map((criteria, index) => {
                criteria.order = index + 1;

                if (typeof criteria.objective_id === 'string') {
                    delete criteria.objective_id;
                }
                return criteria;
            });

        if (payload.criterias.length !== 0) {
            const response = await Objective.api().put(`/api/objectives/${this.id}`, payload);

            const ids = map(response.entities.objective_criterias, 'id');

            await ObjectiveCriteria.delete(criteria => !ids.includes(criteria.id) && criteria.objective_id === this.id);
        } else {
            await Objective.delete(this.id);
            await Objective.api().delete(`/api/objectives/${this.id}`);
        }
    }

    async save() {
        const payload = this.$toJson();

        payload.criterias = ObjectiveCriteria.query()
            .where('objective_id', this.id)
            .where(criteria => !!criteria.description)
            .orderBy('order')
            .get()
            .map((criteria, index) => {
                criteria.order = index + 1;

                if (typeof criteria.objective_id === 'string') {
                    delete criteria.objective_id;
                }
                return criteria;
            });

        if (!payload.criterias.length) {
            return;
        }

        const newObjective = typeof this.id !== 'number';

        const response = newObjective
            ? await Objective.api().post('/api/objectives', payload)
            : await Objective.api().put(`/api/objectives/${this.id}`, payload);

        const ids = map(response.entities.objective_criterias, 'id');

        await ObjectiveCriteria.delete(criteria => !ids.includes(criteria.id) && criteria.objective_id === this.id);
    }
}
